// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/salvar
 *
 * Returns the persisted device id (the id passed in for an update or the
 * insert id for a new record) plus a success message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_SalvarResponseDados {
device_id: number
message: string
}

export type DevicesFranquias_SalvarResponse = ApiResponse<DevicesFranquias_SalvarResponseDados>;

registerResponseContract('DevicesFranquias_SalvarResponse', {
  device_id: { type: 'number',  required: true },
  message:   { type: 'string',  required: true },
})
